module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.images.length < 1 || _vm.sending,
      "color": _vm.outboxColor,
      "large": "",
      "flat": ""
    },
    on: {
      "click": _vm.uploadFile
    }
  }, [_c('v-badge', {
    attrs: {
      "left": "",
      "overlap": "",
      "color": "orange"
    },
    model: {
      value: (_vm.showOutboxCount),
      callback: function($$v) {
        _vm.showOutboxCount = $$v
      },
      expression: "showOutboxCount"
    }
  }, [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.imageCount))]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("file_upload")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "text-xs-center"
  }, [_vm._v("Empty Outbox")])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ba7ec15","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadJobs.vue
// module id = 672
// module chunks = 1